import { render, staticRenderFns } from "./ReportesInformeCompleto.vue?vue&type=template&id=efdde2b2&scoped=true&"
import script from "./ReportesInformeCompleto.vue?vue&type=script&lang=js&"
export * from "./ReportesInformeCompleto.vue?vue&type=script&lang=js&"
import style0 from "./ReportesInformeCompleto.vue?vue&type=style&index=0&id=efdde2b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdde2b2",
  null
  
)

export default component.exports